import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	win: 12
};


const stepThree = {
	remove_products: steps.dialogFive,
	accommodate_products: steps.dialogSix,
};

const stepThreeAudio = {
	remove_products: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a05T3)
		}
	},
	accommodate_products: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a06T3)
		}
	},
};

export const Theme3SubtopicThreeActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema3], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 3 act 3");
			ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic3.actThree.finishActScene, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)

		const stepAudio = stepThreeAudio[step]
		stepAudio.action()

	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 3: Manejo de merma" />
					<DialogBarNew
						dialog={`Gracias a la zona de Fast Food, has aplicado el manejo de merma, que es crucial para productos no vendibles debido a caducidad o mal estado.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Inocuidad "
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a02T3)
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>

					<DialogBarNew
						dialog={`Vas por muy buen camino en tu recorrido. Te mostraré con más detalle los pasos a seguir para el manejo adecuado de la merma.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a03T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene, "view_expiration")
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Paso 1: Si encuentras productos caducos en Piso de Venta, retíralos, ponlos en una bolsa de plástico y colócalos en el contenedor de mermas ubicado en el Cuarto Frío.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a04T3)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Paso 2: Una noche antes de la fecha de su vencimiento, retira los productos de Piso de Venta.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene, "remove_products")
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Paso 3: Coloca los productos más próximos a caducar al frente de la Góndola, exhibidor o parrilla del Cuarto Frío.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene, "accommodate_products")
							ObserverEmitter.emit(EVENTS.characterAnimations.pensativo)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Paso 4: Retira los productos perecederos que no cuenten con etiquetas de caducidad.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a07T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene, "remove_not_ticket")
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`¡Excelente! Ahora, te mostraremos consideraciones sobre productos en mal estado en Fast Food.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a08T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene, "expired_sausage")
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`Salchichas: color oscuro, perdida de volumen y arrugas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a09T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene, "expired_frut")
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Verdura: mal olor, resequedad, partículas ajenas o cristalización, tomate aguado.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_3.sub3_act3_a10T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene, "expired_bread")
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Pan: duro o reseco, recuerda que el pan debes conservarlo y entregarlo al proveedor en su siguiente visita.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actThree.actScene)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}


			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda que debemos ser muy observadores al momento de revisar los productos precederos."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema3
								})
							);
							navigator("/home3/tema3/subtema3/activityFour");
						}}
					/>
				</>
			)}
		</>
	)
}